import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const HandshakeIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 35, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 20) / 35}
      viewBox="0 0 35 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.0535 15.217C24.8337 15.7216 24.5 16.092 24.0523 16.328C23.393 16.6739 22.5058 16.6902 21.6797 16.3809C21.293 16.2344 20.8576 16.4013 20.6704 16.7716C19.6773 18.7048 17.8215 19.36 15.9372 18.4402C15.5669 18.2612 15.1192 18.3833 14.8954 18.7292C14.3785 19.535 13.6907 19.946 11.8675 19.5146C11.1227 19.3356 10.439 18.9408 9.88548 18.371L6.13314 14.5048C6.01513 14.3867 5.86455 14.3053 5.70175 14.2728L0.565265 13.2866C0.237175 13.2236 0 12.9365 0 12.6024V4.08554C0 3.65536 0.38604 3.328 0.810439 3.39828L6.41396 4.32629C6.65408 4.37105 6.90233 4.2978 7.08548 4.135C10.1907 1.40825 13.2959 0.248376 16.5314 0.622788L10.2477 6.63384C9.85699 7.00825 9.64128 7.53324 9.65757 8.07046C9.66977 8.61174 9.91802 9.12454 10.3291 9.47453L10.9233 9.98325C12.8238 11.603 15.6238 11.5298 17.439 9.82048L20.414 7.02047C20.9796 9.89373 22.4122 13.1577 25.0535 15.217Z"
        fill="currentColor"
      />
      <path
        d="M34.9998 4.12452V12.3558C34.9998 12.7072 34.7381 13.0036 34.3895 13.0471L26.2254 14.0657C23.386 11.9584 22.0742 8.09034 21.8104 5.33415C21.7802 5.01782 21.6 4.72176 21.3052 4.60327C21.2 4.56104 21.1002 4.54243 20.9958 4.54243C20.7923 4.54243 20.5888 4.61975 20.4382 4.76626L16.3237 8.63661C15.1109 9.77614 13.2429 9.82093 11.9812 8.7465L11.383 8.23778C11.2975 8.16453 11.2853 8.07498 11.2812 8.02614C11.2812 7.97731 11.2894 7.88779 11.3708 7.81046L18.2202 1.2622C18.383 1.10754 18.5539 0.96511 18.7289 0.838949C18.7655 0.81858 18.8022 0.794163 18.8347 0.769745C20.369 -0.259893 22.4243 -0.26804 23.9789 0.814531L28.8382 4.19243C29.0173 4.31859 29.2371 4.36743 29.4527 4.32674L34.1746 3.43987C34.6034 3.35934 34.9998 3.68825 34.9998 4.12452Z"
        fill="currentColor"
      />
    </svg>
  )
})

HandshakeIcon.displayName = 'HandshakeIcon'
